import React, { useState } from "react";
import moment from "moment";

// hooks
import { makeStyles, createStyles } from "@mui/styles";

// components
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  Link,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import Dialog from "../../components/Dialog";

const MEAL_MAP = {
  dorucak: "doručak",
  rucak: "ručak",
  vecera: "večera",
  uzina: "užina",
};

const useStyles = makeStyles((opts) => {
  const {
    palette: {
      info: { main: infoColor },
      secondary: { main: secondaryColor },
    },
    breakpoints,
  } = opts;

  return createStyles({
    root: {
      padding: 6,
      marginBottom: 12,
      borderBottom: "1px dotted #ccc",
      "&:last-child": {
        border: "none",
        marginBottom: 0,
      },
      [breakpoints.down("xs")]: {
        marginBottom: 24,
      },
    },
    itemTime: {
      color: infoColor,
      fontWeight: 300,
      textAlign: "right",
      paddingTop: 24,
      [breakpoints.down("xs")]: {
        paddingTop: 0,
        textAlign: "left",
      },
    },
    itemMeal: {
      color: secondaryColor,
      fontWeight: 300,
      textAlign: "left",
      paddingLeft: 12,
      paddingTop: 24,
      [breakpoints.down("xs")]: {
        paddingTop: 0,
        textAlign: "right",
      },
    },
    itemDish: {
      textAlign: "left",
      [breakpoints.down("xs")]: {
        textAlign: "center",
        paddingTop: 12,
      },
    },
    dishName: {
      cursor: "pointer",
    },
    recipeContent: {
      whiteSpace: "pre-line",
    },
  });
});

const PlanItem = (props) => {
  const { date, meal, data: items } = props;

  const classes = useStyles();
  const [recipeToShow, setRecipeToShow] = useState(null);
  const closeRecipe = () => setRecipeToShow(null);

  const time = (date) => moment(date).format("HH:mm");
  const amount = (item) => {
    const { amount, unit = {} } = item;
    if (!parseFloat(amount) > 0) return null;

    return `${amount} ${unit?.sign}`;
  };

  const renderItem = (item) => {
    const {
      id,
      dish: { name, recipe },
    } = item;

    const dishLink = (
      <Link
        className={classes.dishName}
        onClick={() => setRecipeToShow({ name: name, recipe: recipe })}
      >
        {name}
      </Link>
    );
    const dishName = recipe ? dishLink : name;

    return (
      <ListItem key={id}>
        <ListItemText primary={dishName} secondary={amount(item)} />
      </ListItem>
    );
  };

  return (
    <Grid container className={classes.root}>
      <Grid item xs={2} sm={2} className={classes.itemTime}>
        {time(date)}
      </Grid>
      <Grid item xs={10} sm={2} className={classes.itemMeal}>
        {MEAL_MAP[meal]}
      </Grid>
      <Grid item xs={12} sm={8} className={classes.itemDish}>
        <List>{items.map(renderItem)}</List>
      </Grid>
      <Dialog open={recipeToShow !== null} onClose={closeRecipe}>
        <DialogTitle>{recipeToShow?.name}</DialogTitle>
        <DialogContent className={classes.recipeContent}>
          {recipeToShow?.recipe}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeRecipe} variant="contained" color="primary">
            Zatvori
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default PlanItem;
